export default class Poll {
    // Constructor
    constructor() {
        this.reveals = {};
    }

    // Init before frameworks
    init() {
        this.setEvent_gfPostRender();
    }

    // Init after frameworks
    initAfterFrameworks() { }

    // Destroy
    destroy() { }

    setEvent_gfPostRender() {
        jQuery(document).on('gform_post_render', function(event, form_id, current_page) {
            if (document.querySelector('.gform_wrapper .validation_error')) {
                const validationMessages = document.querySelectorAll('.gform_wrapper .validation_message');
                let alertMessage = '';

                validationMessages.forEach(function(message) {
                    const fieldID = message.id.replace('validation_message', 'field');
                    const fieldLabel = document.querySelector(`#${fieldID} .gfield_label`);
                    let text = '';
                    if (fieldLabel) {
                        text += `${fieldLabel.innerText}: `;
                    }
                    text += `${message.innerText}\n`;
                    alertMessage += text;
                });

                window.alert(alertMessage);
            }
        });
    }

    maybeCreatePollReveal(form_id) {
        if (!this.reveals.hasOwnProperty(form_id)) {
            const html =
                `<div class="reveal tps-comp-poll-reveal" id="gf_reveal_${form_id}">
                    <div class="tps-comp-poll-reveal-content"></div>
                    <button class="close-button tps-comp-poll-reveal-close" data-close aria-label="Close modal" type="button">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>`;
            const elem = new Foundation.Reveal(jQuery(html), {});
            this.reveals[form_id] = elem;
        }
    }

    openPollResults(form_id, html, confirmation) {
        if (this.reveals.hasOwnProperty(form_id)) {
            this.reveals[form_id].$element.find('.tps-comp-poll-reveal-content').html(html);
            this.reveals[form_id].$element.find('.gpoll_field_label').html(confirmation);
            this.reveals[form_id].$element.foundation('open');
        }
    }
}
